import { render, staticRenderFns } from "./Quiver.vue?vue&type=template&id=054ec536&scoped=true"
import script from "./Quiver.vue?vue&type=script&lang=js"
export * from "./Quiver.vue?vue&type=script&lang=js"
import style0 from "./Quiver.vue?vue&type=style&index=0&id=054ec536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054ec536",
  null
  
)

export default component.exports